import { useContext, useState } from "react";
import { Contexto } from "@Componentes/App";
import * as _api_ from "@Funciones/api";
import * as _f_ from "@Funciones/funciones";
import * as _btn_ from "@Elementos/Boton";
import * as _ipt_ from "@Elementos/Input";
import * as _anim_ from "@Elementos/Animaciones";
import VentaEnTienda from "@VentaEnTienda/VentaEnTienda";
import RegistrosComprobantes from "@RegistrosComprobantes/RegistrosComprobantes";
import GenerarPedidoDist from "@GenerarPedidoDist/GenerarPedidoDist";
import ProductosProduccion from "@ProductosProduccion/ProductosProduccion";
import ListarPedidos from "@Pedidos/ListarPedidos";
import ConfiguracionSistema from "@ConfiguracionSistema/ConfiguracionSistema";
import Personal from "@Personal/Personal";
import Empresas from "@Empresas/Empresas";
import Marcas from "@Marcas/Marcas";
import Etapas from "@Etapas/Etapas";
import CategoriasProductos from "@CategoriasProductos/CategoriasProductos";
import ProductosTerminados from "@Productos/ProductosTerminados";
import RegistroVentaTienda from "@RegistroVentaTienda/RegistroVentaTienda";
import GenerarPedidoProduccion from "@GenerarPedidoProduccion/GenerarPedidoProduccion"
import ListasProduccion from "@ListasProduccion/ListasProduccion";
import StockProducciones from "@StockProducciones/StockProducciones"

import RegistrosDeEmbolsado from "@RegistrosDeEmbolsado/RegistrosDeEmbolsado"

import StockProductos from "@StockProductos/StockProductos";
import Navegacion from "@Navegacion/Navegacion";
import VentaTienda from "@VentaTienda/VentaTienda";
import Testing from "@Testing/Testing.js";
import "./ContenidoCentral.css";

function ContenidoCentral() {
  const { opcionMenu, nomUsuario } = useContext(Contexto);
  const [opciones, setopciones] = useState({
    Personal: <Personal />,
    ListarPedidos: <ListarPedidos/>,
    GenerarPedidoDist: <GenerarPedidoDist/>,
    AdministrarProductos: <ProductosTerminados/>,
    RegistroVentasTienda: <RegistroVentaTienda/>,
    VentaTienda: <VentaEnTienda/>,
    StockProductos: <StockProductos/>,
    Empresas: <Empresas/>,
    CategoriasProductos: <CategoriasProductos/>,
    Marcas: <Marcas/>,
    Etapas: <Etapas/>,
    // Preventistas: <VentaTienda/>,
    ProductosProd: <ProductosProduccion/>,
    CONFSISTEMA : <ConfiguracionSistema/>,

    GenerarPedidoProduccion: <GenerarPedidoProduccion/>, //<GenerarPedidoProduccion/>,
    RegistrosDeEmbolsado: <RegistrosDeEmbolsado/>,
    GenerarPedido: "", //<GenerarPedido/>,
    Asistencias: "", //<Asistencias/>,
    Insumos: "", //<Insumos/>,
    ListaIngresos: "", //<ListaIngresos/>,
    GenerarPedidoInsumos: "", //<GenerarPedidoInsumos/>,
    ListaSalidas: "", //<ListaSalidas/>,
    GenerarSalidaInsumos: "", //<GenerarSalidaInsumos/>,
    StockAlmacen: "", //<StockAlmacen/>,
    
    ListasProduccion: <ListasProduccion/>, //<ListasProduccion/>,
    StockProducciones: <StockProducciones/>, //<StockProducciones/>,
    Comprobantes: <RegistrosComprobantes/>, //<Comprobantes/>,
    Guias: "", //<Guias/>,
    
    Testing : <Testing/>
  });

  return (
    <div className={"cc-app"}>
      <div className={"cc-a-contenedor"}>
        <Navegacion />
        <div className={"cc-a-cuerpo"}>
          <div className={"cc-a-interfaz-ancla"}>
            {opcionMenu != null ? (
              <div className={"cc-a-i-cuerpo"}>
                <div className={"cc-a-i-app"}>{opciones[opcionMenu]}</div>
              </div>
            ) : (
              <div className={"cc-a-principal pan-bienvenida-vapor"}>
                {`${_f_.capitalizarPalabras(_f_.obtenerCookie("nomUsuario"))}, Bienvenido(a) a San Miguel`}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
export default ContenidoCentral;
